import BorseAnnouncements from "./borse-announcements";
import BorseRequests from "./borse-requests";

const BorseContent = () => {
  return (
    <div className="wrapper wrapper--app">
      <BorseRequests />
      <BorseAnnouncements />
    </div>
  );
};

export default BorseContent;
